import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submit", "errors", "field"]
  
  connect() {
    this.validateForm()
    this.setupFieldListeners()
  }
  
  setupFieldListeners() {
    this.fieldTargets.forEach(field => {
      field.addEventListener('blur', () => this.validateField(field))
    })
  }
  
  validateForm() {
    const form = this.element
    const isValid = form.checkValidity()
    
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = !isValid
      
      if (isValid) {
        this.submitTarget.classList.remove("opacity-50", "cursor-not-allowed")
      } else {
        this.submitTarget.classList.add("opacity-50", "cursor-not-allowed")
      }
    }
    
    return isValid
  }
  
  validateField(field) {
    const isValid = field.checkValidity()
    const errorElement = field.parentElement.querySelector('.field-error')
    
    if (!isValid) {
      field.classList.add("border-red-500", "focus:ring-red-500")
      field.classList.remove("border-gray-600", "focus:ring-blue-500")
      
      if (errorElement) {
        errorElement.textContent = field.validationMessage
        errorElement.classList.remove("hidden")
      }
    } else {
      field.classList.remove("border-red-500", "focus:ring-red-500")
      field.classList.add("border-gray-600", "focus:ring-blue-500")
      
      if (errorElement) {
        errorElement.classList.add("hidden")
      }
    }
    
    this.validateForm()
  }
  
  clearErrors() {
    if (this.hasErrorsTarget) {
      this.errorsTarget.innerHTML = ""
    }
    
    this.fieldTargets.forEach(field => {
      field.classList.remove("border-red-500", "focus:ring-red-500")
      field.classList.add("border-gray-600", "focus:ring-blue-500")
      
      const errorElement = field.parentElement.querySelector('.field-error')
      if (errorElement) {
        errorElement.classList.add("hidden")
      }
    })
  }
  
  handleSubmit(event) {
    if (!this.validateForm()) {
      event.preventDefault()
      
      // Show validation messages for all invalid fields
      this.fieldTargets.forEach(field => {
        if (!field.checkValidity()) {
          this.validateField(field)
        }
      })
    }
  }
} 